import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated
 */
import React from "react";
export const ConditionalView = ({ condition, children }) => {
    if (condition) {
        return _jsx(React.Fragment, { children: children });
    }
    return _jsx(React.Fragment, {});
};
//# sourceMappingURL=ConditionalView.js.map